<div *ngrxLet="isPending$; let isPending" class="modal">
  <button
    class="close-round"
    data-qa="dashboard.leverage.close.button"
    [mat-dialog-close]="false"
    >
    <span class="close-round__btn"></span>
  </button>

  <h3 class="title" translate="leverage-popup.main-title"></h3>
  <p class="sub-title" translate="leverage-popup.sub-title"></p>
  <a
    class="link"
    href="https://{{helpCenterDomain}}/{{data.language}}/content/how-can-i-change-my-account-leverage"
    rel="noopener noreferrer"
    target="_blank"
    translate="leverage-popup.read-more"
  ></a>

  <div class="leverages">
    @if (lowRiskLeverages.length) {
      <p class="leverages__title" translate="leverage-popup.low-risk"></p>
      <div class="chips">
        @for (leverage of lowRiskLeverages; track leverage) {
          <global-input-chip
            data-qa="dashboard.leverage.value.radio-button"
            name="leverage"
            [isChecked]="data.currentLeverage === leverage.key"
            [isDisabled]="isPending || !!leverage.value.text || (!data.leverageSetting.isAvailableChange && !data.leverageSetting.isLocked)"
            [isSelected]="checkedLeverage === leverage.key || (!checkedLeverage && data.currentLeverage === leverage.key)"
            [value]="leverage.key"
            (onSelect)="checkedLeverage = leverage.key"
            >
            <ng-container
              [ngTemplateOutlet]="inputContent"
              [ngTemplateOutletContext]="{ leverage }"
            />
          </global-input-chip>
        }
      </div>
    }

    @if (mediumRiskLeverages.length) {
      <p class="leverages__title" translate="leverage-popup.medium-risk"></p>
      <div class="chips">
        @for (leverage of mediumRiskLeverages; track leverage) {
          <global-input-chip
            data-qa="dashboard.leverage.value.radio-button"
            name="leverage"
            [isChecked]="data.currentLeverage === leverage.key"
            [isDisabled]="isPending || !!leverage.value.text || (!data.leverageSetting.isAvailableChange && !data.leverageSetting.isLocked)"
            [isSelected]="checkedLeverage === leverage.key || (!checkedLeverage && data.currentLeverage === leverage.key)"
            [value]="leverage.key"
            (onSelect)="checkedLeverage = leverage.key"
            >
            <ng-container
              [ngTemplateOutlet]="inputContent"
              [ngTemplateOutletContext]="{ leverage }"
            />
          </global-input-chip>
        }
      </div>
    }

    @if (highRiskLeverages.length) {
      <p class="leverages__title" translate="leverage-popup.high-risk"></p>
      <div class="chips">
        @for (leverage of highRiskLeverages; track leverage) {
          <global-input-chip
            data-qa="dashboard.leverage.value.radio-button"
            name="leverage"
            [isChecked]="data.currentLeverage === leverage.key"
            [isDisabled]="isPending || !!leverage.value.text || (!data.leverageSetting.isAvailableChange && !data.leverageSetting.isLocked)"
            [isSelected]="checkedLeverage === leverage.key || (!checkedLeverage && data.currentLeverage === leverage.key)"
            [value]="leverage.key"
            (onSelect)="checkedLeverage = leverage.key"
            >
            <ng-container
              [ngTemplateOutlet]="inputContent"
              [ngTemplateOutletContext]="{ leverage }"
            />
          </global-input-chip>
        }
      </div>
    }
  </div>

  @if (isEquityWarningVisible) {
    <p translate="leverage-popup.warning-equity"></p>
  }

  @if (checkedLeverage > data.currentLeverage) {
    <pac-alert
      data-qa="dashboard.leverage.closed-orders.warning"
      type="warning"
      [description]="'leverage-popup.warning-orders' | translate"
    />
  }

  @if (checkedLeverage < data.currentLeverage) {
    <pac-alert
      data-qa="dashboard.leverage.closing-orders.alert"
      type="negative"
      [description]="'leverage-popup.warning-closing' | translate"
    />
  }

  @if (errorMessage) {
    <span class="error">{{ errorMessage }}</span>
  }

  <btn
    data-e2e-element="leverage-popup.button.submit"
    data-qa="dashboard.leverage.confirm.button"
    wide="true"
    [buttonText]="'leverage-popup.button.' + (isRequestFailed ? 'try-again' : 'confirm')"
    [disabled]="!checkedLeverage || isPending || checkedLeverage === data.currentLeverage"
    [loading]="isPending"
    (action)="submit()"
  />
</div>

<ng-template #inputContent let-leverage='leverage'>
  <span>1:<bdi>{{ leverage.key }}</bdi></span>
  @if (data.currentLeverage === leverage.key) {
    <svg-icon-sprite
      class="checkmark"
      height="12"
      width="12"
      [src]="'./assets/img/icons/sprite.svg#check'"
    />
  }
</ng-template>
